import loadingImage from "../img/loading-animation.gif";
import React from "react";

const Loading = () => {
    return (
        <>
            <div className="card-body shadow-none">
                <div className="text-center justify-content-center align-items-center">
                    <img src={loadingImage} alt="Loading"/>
                </div>
            </div>
        </>
    );
}

export default Loading;